import React, { useEffect, useState } from 'react'
import { checkAuth } from './utils/auth'
import useCookie from './utils/useCookie'
import Routes from './routes'
import axios from 'axios'
import { Layout, Col, Row, ConfigProvider } from 'antd'
import locale from 'antd/lib/locale/it_IT'
import Header from './components/header'
import { BrowserRouter } from 'react-router-dom'
import Progress from 'react-progressbar'
import TagManager from 'react-gtm-module'
import qs from 'query-string'

const App = () => {
  const [value] = useCookie('8egma2jfs9mu')
  const [redirect, setRedirect] = useState(false)
  const [authenticated, setAuth] = useState(false)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (redirect) {
      window.location.href =
        process.env.REACT_APP_API_URL +
        `/auth/register?from=${encodeURIComponent(window.location.href)}`
    }
  }, [redirect])

  useEffect(() => {
    const dataLayer = {
      pageTitle: 'Zappyrent - Carica Annuncio',
      pageType: 'upload-property',
      pageLanguage: 'it',
      trackCode: qs.parse(window.location.search)?.tr,
      city: null,
    }

    checkAuth(value)
      .then((res) => {
        const { data: { data: user } = {} } = res
        TagManager.dataLayer({
          dataLayer: {
            ...dataLayer,
            userType: user?.user_type,
            userId: user?.id,
            visitorLoginState: 'logged-in',
          },
        })
        setAuth(user.id)
        axios.defaults.headers.Authorization = `Bearer ${res.data.data.api_token}`
      })
      .catch(() => {
        TagManager.dataLayer({
          dataLayer: {
            ...dataLayer,
            userType: null,
            userId: null,
            visitorLoginState: 'logged-out',
          },
        })
        setRedirect(true)
      })
  }, [])
  if (!authenticated) {
    return null
  }
  return (
    <ConfigProvider locale={locale}>
      <Layout>
        <BrowserRouter>
          <Layout.Header
            style={{ zIndex: 1, width: '100%', padding: 0 }}
            className="shadow-lg fixed top-0"
          >
            <Row justify="center">
              <Col xs={24} md={22} xl={18}>
                <Header />
              </Col>
            </Row>
            <Progress completed={progress} />
          </Layout.Header>
          <Layout.Content className="p-4 pt-24">
            <Row justify="center">
              <Col xs={24} md={22} xl={18}>
                <Routes
                  setProgress={setProgress}
                  progress={progress}
                  userId={authenticated}
                />
              </Col>
            </Row>
          </Layout.Content>
        </BrowserRouter>
      </Layout>
    </ConfigProvider>
  )
}

export default App
